import React from 'react';
import { styled } from '@mui/material';
import moment from 'moment';
import { MessageBubble, Row, Text } from 'library/ui';
import { Message } from 'models/Message';
import { useUserContext } from 'UserContext';

interface IThreadProps {
    message: Message;
    user: { id: number };
}

export const Thread = ({ message, user }: IThreadProps) => {
    const { user: contextUser } = useUserContext();

    const isOwn =
        message.sender.id === user.id || !!contextUser?.businesses_active?.some((x) => x.user.id === message.sender.id);

    const imageUrl = message.image ? message.image['image'] || message.image['url'] : null;

    return (
        <Row justify={isOwn ? 'end' : 'start'} fullWidth>
            <MessageBubble tone={isOwn ? 'sent' : 'received'}>
                {message.message && (
                    <Text component="div" tone="inherit" lineHeight="relaxed">
                        {message.message}
                    </Text>
                )}
                {imageUrl && <BubbleImage src={imageUrl} />}
                <Row justify="end">
                    <Text size="sm" tone={isOwn ? 'overlay' : 'secondary'}>
                        {moment(message.sent_at).format('h:mm A')}
                    </Text>
                </Row>
            </MessageBubble>
        </Row>
    );
};

const BubbleImage = styled('img')({
    display: 'block',
    maxWidth: 200,
    maxHeight: 200,
    borderRadius: 8,
});
